var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      class: {
        "dark-bg-theme": _vm.darkBgTheme,
        "large-theme": _vm.largeTheme,
        "referral-theme": _vm.referralTheme,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _vm.imageSrc || _vm.spriteClass
        ? _c("div", { staticClass: "img" }, [
            _vm.spriteClass
              ? _c("span", { class: _vm.spriteClass })
              : _c("img", { attrs: { src: _vm.imageSrc, alt: _vm.imageAlt } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("p", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.description))
      ]),
      _vm._v(" "),
      _vm.buttonText
        ? _c(
            "p",
            { staticClass: "button-wrapper" },
            [
              _c("ReferralButton", {
                attrs: { text: _vm.buttonText, loading: _vm.loading },
                on: { "button-clicked": _vm.clickHandler }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }